import {schemaMigrations, addColumns} from '@nozbe/watermelondb/Schema/migrations';

export const migrations = schemaMigrations({
  migrations: [
    {
      toVersion: 27,
      steps: [
        addColumns({
          table: 'users',
          columns: [
            {
              name: 'phone_verified',
              type: 'boolean',
              isOptional: true,
            },
          ],
        }),
      ],
    },
  ],
});

export default migrations;
